import React, { useMemo } from "react";
import "./SystemStatusStartItem.scss";
import SystemStatusIcon from "./SystemStatusIcon";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { Colors, SmallBodyBolder, SmallHeading } from "src/components";
import { ReactSVG } from "react-svg";
import { Style } from "src/ui/helpers";
import { SystemStatusBannerType } from "./utils";
import { Link } from "react-router-dom";
import { SpintrTypes } from "src/typings";

interface IProps {
    title?: string;
    icon?: string;
    imageUrl?: string;
    iconType?: "system-status" | "default";
    renderMainContent?: () => React.ReactNode;
    renderRightContent?: () => React.ReactNode;
    type: SpintrTypes.SystemStatusType;
    url?: string;
    solidInnerCircle?: boolean;
    isCategory?: boolean;
    isBanner?: boolean;
}

const SystemStatusStartItem = (props: IProps) => {
    const textColor: Colors = useMemo(() => props.type === SpintrTypes.SystemStatusType.Information || props.type === SpintrTypes.SystemStatusType.Done ? "contentDark" : "white", [props.type]);
    const iconColor = useMemo(() => {
        const iconColors: Record<string, spintrColors> = {
            [SpintrTypes.SystemStatusType.AllClear]: "dark-grey",
            [SpintrTypes.SystemStatusType.Done]: "dark-grey",
            [SpintrTypes.SystemStatusType.Ongoing] : "dark-grey",
            [SpintrTypes.SystemStatusType.Planned] : "white",
            [SpintrTypes.SystemStatusType.Information] : "light-blue",
        }
        
        return iconColors[props.type];
    }, [props.type]);

    const icon = useMemo(() => {
        if (props.imageUrl) {
            return (
                <img
                    src={props.imageUrl}
                    className="system-status-image"
                    alt={props.title || ""}
                />
            )
        }

        if (props.iconType === "system-status") {
            return (
                <ReactSVG
                    src={"/images/system-status-icons/" + (props.icon || "service") + ".svg"}
                    className="system-status-icon"
                    style={{color: Style.getHexFromSpintrColor(iconColor)}}
                />
            )
        }

        return (
            <Visage2Icon icon={props.icon} color={iconColor} />
        )
    }, [props.type, props.icon, props.imageUrl, props.title, iconColor]);

    const result = (
        <div className={[
            "SystemStatusStartItem",
            "type-" + props.type,
            "is-" + (props.isCategory ? "category" : "item"),
            props.solidInnerCircle ? "solid-inner-circle" : "",
            props.isBanner ? "is-banner" : "",
            props.imageUrl ? "has-image" : ""
        ].join(" ")}>
             <div className="icon">
                <div className="icon-inner">
                    {icon}
                </div>
            </div>
            <div className="wrap">
                <div className="content">
                    {!!props.title && <SmallHeading color={textColor}>{props.title}</SmallHeading>}
                    {!!props.renderMainContent && props.renderMainContent()}
                </div>
                {!!props.renderRightContent && (
                    <div className="right">
                        {props.renderRightContent()}
                    </div>
                )}
            </div>
        </div>
    )

    if (props.url) {
        return (
            <Link to={props.url} className="SystemStatusStartItem-link">
                {result}
            </Link>
        )
    }

    return result;
}

export default SystemStatusStartItem;
